import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { GetjobConfiguration } from "../service/jobconfigApi";

const SidebarContext = createContext({
  getConfiguration: () => {},
  jobConfigs: [],
  setJobConfigs: () => [],
});

export default function SidebarProvider({ children }) {
  const [jobConfigs, setJobConfigs] = useState(null);

  const getConfiguration = async () => {
    try {
      console.log("qwertyuiop flag2");
      const response = await GetjobConfiguration();
      setJobConfigs(response?.data);
    } catch (error) {
      console.error("Error fetching job configurations:", error);
      toast.error("An error occurred while fetching job configurations.");
    }
  };

  return (
    <SidebarContext.Provider
      value={{ getConfiguration, jobConfigs, setJobConfigs }}
    >
      {children}
    </SidebarContext.Provider>
  );
}

export const useSidebar = () => useContext(SidebarContext);
